import { ActionTree, MutationTree } from 'vuex'
import { IMeta } from '~/assets/interfaces/meta'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'

interface IState {
  breadcrumbs: IBreadcrumbsItem[]
  meta: IMeta
}

export const state = (): IState => ({
  meta: {
    title: '',
    description: '',
    keywords: '',
    h1: '',
  },
  breadcrumbs: [],
})

export const mutations: MutationTree<IState> = {
  setMeta(state: IState, val: IMeta) {
    state.meta = val
  },
  setBreadcrumbs(state: IState, val: IBreadcrumbsItem[]) {
    state.breadcrumbs = val
  },
}

export const actions: ActionTree<IState, IState> = {}
